import { render, staticRenderFns } from "./SelectCategories.vue?vue&type=template&id=36c61fde&scoped=true"
import script from "./SelectCategories.vue?vue&type=script&lang=js"
export * from "./SelectCategories.vue?vue&type=script&lang=js"
import style0 from "./SelectCategories.vue?vue&type=style&index=0&id=36c61fde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c61fde",
  null
  
)

export default component.exports